<template>
  <div class="topbar">
    <LangSwitch />
    <QuoteSelect />
    <div class="wallet">
      <span v-if="networkLabel" class="net" :class="netClass">{{ networkLabel }}</span>
      <div v-if="fullAddress" class="addr" :title="fullAddress">{{ displayAddress }}</div>
      <button v-else class="connect" :disabled="connecting" @click="connect">
        {{ connecting ? $t("connecting") : $t("connect") }}
      </button>
    </div>

    <div v-if="error" class="err" @click="error = ''">{{ error }}</div>
  </div>
</template>

<script>
import LangSwitch from "./LangSwitch.vue";
import QuoteSelect from "./QuoteSelect.vue";
import { sessionState } from "../session";
import { autoConnectWallet, getPreferredChain } from "../recovered/wallet-session";
import { loadChainConfig } from "../quote";

export default {
  name: "AppHeader",
  components: { LangSwitch, QuoteSelect },
  i18n: {
    zh: {
      connect: "连接钱包",
      connecting: "连接中…",
      failed: "连接钱包失败",
    },
    en: {
      connect: "Connect",
      connecting: "Connecting…",
      failed: "Failed to connect wallet",
    },
  },
  data() {
    return { connecting: false, error: "" };
  },
  mounted() {
    // 顶部选择器要链表；首页也会用到同一份 config，内部共享同一个请求
    loadChainConfig().catch(() => {});
  },
  beforeDestroy() {
    if (this.errTimer) clearTimeout(this.errTimer);
  },
  methods: {
    async connect() {
      if (this.connecting) return;
      this.connecting = true;
      this.error = "";
      try {
        // force：显式点击就走完整连接流程（会弹钱包授权窗）
        const result = await autoConnectWallet({
          force: true,
          preferredChain: getPreferredChain() || sessionStorage.getItem("CHAIN") || "",
        });
        if (!result || !result.ok) {
          throw new Error((result && result.errorMessage) || this.$t("failed"));
        }
      } catch (err) {
        this.showError((err && err.message) || this.$t("failed"));
      } finally {
        this.connecting = false;
      }
    },
    showError(message) {
      this.error = message;
      if (this.errTimer) clearTimeout(this.errTimer);
      this.errTimer = setTimeout(() => {
        this.error = "";
      }, 5000);
    },
  },
  computed: {
    fullAddress() {
      return sessionState.address || sessionStorage.getItem("ADDRESS") || localStorage.getItem("U_ADDRESS") || "";
    },
    displayAddress() {
      const a = this.fullAddress;
      if (!a) return "0x0000...0000";
      if (a.length <= 14) return a;
      return `${a.slice(0, 6)}...${a.slice(-4)}`;
    },
    networkLabel() {
      if (!this.fullAddress) return "";
      const map = { ERC20: "ETH", BASE: "Base", TRC20: "TRON", SOL: "SOL" };
      return map[sessionState.chain] || "";
    },
    netClass() {
      return sessionState.chain === "BASE" ? "net-base" : "";
    },
  },
};
</script>

<style scoped>
.topbar {
  position: relative;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
}

.wallet {
  display: flex;
  align-items: center;
  gap: 6px;
}

.net {
  height: 22px;
  line-height: 22px;
  padding: 0 8px;
  border-radius: 11px;
  font-size: 11px;
  font-weight: 700;
  color: #cdd6ee;
  background: rgba(150, 170, 225, 0.12);
  border: 1px solid rgba(150, 167, 214, 0.22);
  white-space: nowrap;
}

.net.net-base {
  color: #ffffff;
  background: linear-gradient(120deg, #2f7bff, #0052ff);
  border-color: transparent;
}

.addr {
  max-width: 120px;
  height: 30px;
  line-height: 30px;
  padding: 0 14px;
  border-radius: 15px;
  background: linear-gradient(120deg, #3f7bff, #4b86ff);
  color: #fff;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.connect {
  height: 30px;
  padding: 0 16px;
  border: 0;
  border-radius: 15px;
  background: var(--pool-grad, linear-gradient(120deg, #33e2c7, #4b86ff));
  color: #04211c;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}
.connect:active {
  opacity: 0.85;
}
.connect:disabled {
  opacity: 0.6;
  cursor: default;
}

.err {
  position: absolute;
  top: 48px;
  right: 14px;
  left: 14px;
  z-index: 20;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid rgba(251, 111, 134, 0.35);
  background: rgba(40, 18, 26, 0.96);
  color: var(--pool-bad, #fb6f86);
  font-size: 12px;
  line-height: 1.5;
  text-align: left;
  word-break: break-word;
}
</style>
